import React from 'react';
import ReactDOM from 'react-dom';
import App from './app/App';
import DemoApp from './app/DemoApp';
import './locales/i18n';
import { GlobalContexProvider, isDemo } from './app/GlobalContex';

ReactDOM.render(
  <GlobalContexProvider>
    {isDemo ? <DemoApp /> : <App />}
  </GlobalContexProvider>,
  document.getElementById('root')
);
